
import React, { useContext, useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LanguageContext } from './LanguageContext';
import './css/Home.css';
import financeImg from "./images/finance.png";
import agencyImg from "./images/agency.png";
//import softwareImg from "./images/softwareIQ.JPG";
import budgetImg from "./images/budget3.jpg";
import guides from "./GuidesFiles";
import investImg from "./images/investparabr.jpg";
import heroImg from "./images/hero.png";
import calculatorImg from "./images/blogpage/aposentometro.png";

const HomePage = () => {
  const { language, toggleLanguage, translations } = useContext(LanguageContext);
  const [showNews, setShowNews] = useState(true);
  const scrollRef = useRef(null);
  const LOCAL_URL = `${process.env.PUBLIC_URL || ''}/files/Planilha.xlsx`;
  const location = useLocation();

  // Handle scroll to section from URL query param
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const scrollTo = params.get("scrollTo");
    if (scrollTo) {
      setTimeout(() => {
        document.getElementById(scrollTo)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location]);

  const scrollGuides = (direction) => {
  if (scrollRef.current) {
    const { current } = scrollRef;
    const scrollAmount = current.offsetWidth * 0.8; // Scroll 80% of visible width

    current.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  }
};

// Example: Home.js

const newsBannerStyle = {
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "12px",
  padding: "8px 16px",
  minHeight: "44px",
  background:
  "radial-gradient(800px 260px at 15% 20%, rgba(255,111,97,0.07),transparent 60%),"+
  "radial-gradient(700px 260px at 85% 10%, rgba(36,85,128,0.14), transparent 55%)," +
  "linear-gradient(180deg, rgba(255,255,255,0.96), rgba(247,249,251,0.96))",
  borderBottom: "1px solid rgba(0,0,0,0.08)",
  fontSize: "0.95rem",
  fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
  color: "#3b2f10",
};

const newsTextStyle = {
  display: "inline-flex",
  alignItems: "center",
  flexWrap: "wrap",
  textAlign: "center",
};

const newsPriceStyle = {
  marginLeft: "6px",
  color: "#b91c1c",
  fontWeight: 900,
  
};

const newsActionsStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  marginLeft: "12px",
};

const newsLinkStyle = {
  textDecoration: "none",
  backgroundColor: "#d83605",
  color: "#ffffff",
  fontWeight: 700,
  padding: "6px 14px",
  borderRadius: "999px",
  fontSize: "0.85rem",
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  cursor: "pointer",
};

const newsCloseStyle = {
  background: "none",
  border: "none",
  fontSize: "1.2rem",
  lineHeight: 1,
  cursor: "pointer",
  color: "#6b4b16",
  padding: "0 4px",
  position: "static",      // 👈 cancela o absolute do CSS
  marginLeft: "4px",       // pequeno espaço depois do botão "Ver curso"
};

const newsCourseStyle = {
  fontWeight: 800,
  color: "#245580", // same as button
  marginLeft: "12px",
};

const isMobile = window.innerWidth <= 480;

const newsPriceComputedStyle = isMobile
  ? {
      ...newsPriceStyle,
      display: "block",
      marginLeft: 0,
      marginTop: "4px",
      textAlign: "center",
    }
  : {
      ...newsPriceStyle,
      display: "inline-block",
      marginLeft: "10px", // 👈 mais espaço no desktop
    };




  return (
    <div className="home-container">
      {/* Language Selector */}
      <button className="language-button" onClick={toggleLanguage}>
        {language === "en" ? "🇧🇷 Português" : "🇺🇸 English"}
      </button>

      {/* News Banner */}
{showNews && (
  <section className="news-banner" style={newsBannerStyle}>
    <span className="news-text" style={newsTextStyle}>
      🎉 <strong style={{ color: "#0b1220" }}>
        {language === "en" ? "New course:" : "Novo curso:"}
      </strong>

      <strong style={newsCourseStyle}>
        {" "}
        {language === "en"
          ? "Investing in the U.S. for Brazilians – Complete Guide"
          : "Investindo nos EUA para Brasileiros – Manual Completo"}
      </strong>

      <span className="news-price" style={newsPriceComputedStyle}>

      </span>
    </span>

    <div className="news-actions" style={newsActionsStyle}>
      <Link to="/investparabr" className="news-link" style={newsLinkStyle}>
        {translations.newsBannerLink}
      </Link>
      <button
        className="news-close"
        style={newsCloseStyle}
        onClick={() => setShowNews(false)}
        aria-label="Close news banner"
      >
        ×
      </button>
    </div>
  </section>
)}

     {/* HERO (new) */} 
<section className="hero" aria-label="Hero">
  <div className="hero-inner">
    {/* LEFT */}
    <div className="hero-left">
      {/*<div className="hero-badge">
        <span className="hero-badge-dot" aria-hidden="true" />
        <span>
          {language === "en"
            ? "New: Learn investing in the U.S. in Portuguese"
            : "Novo: Aprenda a investir nos EUA em Português"}
        </span>
      </div> */}

      <h1 className="hero-title">
        <span className="hero-title-line">
          {translations.welcomeMessagePart1}
        </span>
        <span className="hero-title-line hero-title-accent">
          {translations.welcomeMessagePart2}
        </span>
      </h1>

      <p className="hero-subtitle">
        {language === "en"
          ? "Simple, practical financial education for Brazilians in the U.S. Courses, guides, checklists, and a step-by-step path to your first investment."
          : "Educação financeira prática para brasileiros nos EUA. Cursos, guias, checklists e um passo a passo claro até o seu primeiro investimento."}
      </p>

      {/* “What’s included” mini-card */}
      <div className="hero-card">
        <div className="hero-card-title">
          {language === "en" ? "What you get" : "O que você encontra aqui"}
        </div>
        <ul className="hero-list">
          <li>
            <span className="hero-check" aria-hidden="true">✓</span>
            <span>
              {language === "en"
                ? "Free guides + practical templates"
                : "Guias grátis + planilhas e templates"}
            </span>
          </li>
          <li>
            <span className="hero-check" aria-hidden="true">✓</span>
            <span>
              {language === "en"
                ? "Premium courses (from zero to execution)"
                : "Cursos premium (do zero à execução)"}
            </span>
          </li>
          <li>
            <span className="hero-check" aria-hidden="true">✓</span>
            <span>
              {language === "en"
                ? "Clear steps for accounts, ETFs, and strategy"
                : "Passo a passo para conta, ETFs e estratégia"}
            </span>
          </li>
        </ul>
      </div>

      <div className="hero-actions">
        <Link to="/courses" className="btn-primary">
          {translations.exploreCourses}
        </Link>

        <Link to="/blog-guides" className="btn-secondary">
          {language === "en" ? "See free guides →" : "Ver guias grátis →"}
        </Link>
      </div>

      {/* Optional 3-metric row (like your landing page listUser) */}
      <div className="hero-metrics" role="list">
        <div className="hero-metric" role="listitem">
          <div className="hero-metric-num">100%</div>
          <div className="hero-metric-label">
            {language === "en" ? "Portuguese" : "Em Português"}
          </div>
        </div>
        <div className="hero-metric" role="listitem">
          <div className="hero-metric-num">
            {language === "en" ? "Step-by-step" : "Passo a passo"}
          </div>
          <div className="hero-metric-label">
            {language === "en" ? "Beginner friendly" : "Sem experiência"}
          </div>
        </div>
        <div className="hero-metric" role="listitem">
          <div className="hero-metric-num">
            {language === "en" ? "U.S. focused" : "Foco EUA"}
          </div>
          <div className="hero-metric-label">
            {language === "en" ? "Real context" : "Contexto real"}
          </div>
        </div>
      </div>
    </div>

    {/* RIGHT */}
    <div className="hero-right" aria-hidden="true">
      {/* Use an image you already have, or import a new hero image */}
      <img
        className="hero-image"
        src={heroImg}
        alt=""
        loading="eager"
      />
    </div>
  </div>
</section>



      {/* Featured Classes Section */}
      <section className="featured-classes">
        <h2>{translations.featuredCourses}</h2>
        <div className="classes-grid">
          <Link to="/investparabr" className="class-card-link">
            <div className="class-card">
              <span className="course-badge course-badge--trial">
                {language === "pt" ? "Módulo 0 Grátis" : "Module 0 Free"}
              </span>
              <h3>{translations.InvestindonosEuaCourse}</h3>
              <p>{translations.investnoseuadescription2}</p>
              <div className="image-wrapper">
                <img src={investImg} alt="Investindo nos EUA" />
                <span className="overlay-btn">
                  {translations.learnMore}
                </span>
              </div>
            </div>
          </Link>

          <Link to="/stock-trade" className="class-card-link">
            <div className="class-card">
              <span className="course-badge course-badge--free">
                {language === "pt" ? "Grátis" : "Free"}
              </span>
              <h3>{translations.stockTradingBasicsTitle}</h3>
              <p>{translations.stockTradingDescription}</p>
              <div className="image-wrapper">
                <img src={agencyImg} alt="Stock Trading" />
                <span className="overlay-btn">
                  {translations.learnMore}
                </span>
              </div>
            </div>
          </Link>

          <Link to="/personal-finance" className="class-card-link">
            <div className="class-card">
              <span className="course-badge course-badge--trial">
                {language === "pt" ? "Módulo 0 Grátis" : "Module 0 Free"}
              </span>
              <h3>{translations.personalFinance}</h3>
              <p>{translations.personalDescription}</p>
              <div className="image-wrapper">
                <img src={financeImg} alt="Personal Finance" />
                <span className="overlay-btn">
                  {translations.learnMore}
                </span>
              </div>
            </div>
          </Link>
        </div>
      </section>

      {/* Download Section */}
<section id="download-section" className="download-section">
  <div className="download-wrap">
    {/* Image first so it appears above on mobile; CSS reflows on desktop */}
    <div className="download-media">
      <img src={budgetImg} alt="Exemplo da Planilha 50/30/20" />
    </div>

    <div className="download-card download-card--compact">
      <h2>{translations.downloadTitle}</h2>

      <p className="download-sub">
        {translations.downloadSubtitle}
      </p>

      <a
        className="cta-button download-button download-button--green"
        href={LOCAL_URL}
        download="Planilha.xlsx"
        aria-label={translations.downloadCTA || "Download (XLSX)"}
      >
        {translations.downloadCTA || "Download"}
        <svg
          className="icon-down"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path d="M12 4v12m0 0l-5-5m5 5l5-5M5 20h14"
                stroke="currentColor" strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </a>

      <div className="download-meta">XLSX • ~100 KB</div>
      <div className="download-note">{translations.downloadNote}</div>
    </div>
  </div>
</section>


      {/* Calculator Section */}
      <section className="calculator-section">
        <div className="calculator-wrap">
          <img src={calculatorImg} alt="Retirement Calculator" className="calculator-image" />
          <h2 className="calculator-title">
            {language === "en"
              ? <>Find Your <span>Retirement Number</span></>
              : <>Descubra Seu <span>Número da Aposentadoria</span></>}
          </h2>
          <p className="calculator-desc">
            {language === "en"
              ? "Use our free calculator to estimate how much you need to retire comfortably in the U.S. based on withdrawal rate scenarios (4%, 3.5%, 3%)."
              : "Use nossa calculadora gratuita para estimar quanto você precisa para se aposentar nos EUA com base em diferentes taxas de saque (4%, 3,5%, 3%)."}
          </p>
          <Link to="/retirementcalculator" className="calculator-btn">
            {language === "en" ? "Open Calculator →" : "Abrir Calculadora →"}
          </Link>
        </div>
      </section>

      {/* Payment Call-to-Action Section */}
      <section className="payment-section">
        <h2>{translations.getMore}</h2>
        <p>{translations.getMoreDesc}</p>
        <Link to="/tutoring">
          <button className="cta-button premium-button">{translations.learnMore}</button>
        </Link>
      </section>

      {/* Guides Section */}
      <section className="guides-section">
  <h2>{translations.featuredGuides || "Featured Guides"}</h2>

  <div className="guides-wrapper">
    <button className="scroll-btn left" onClick={() => scrollGuides('left')}>
      &lt;
    </button>
    <div className="guides-container" ref={scrollRef}>
      {guides.map((guide) => (
        <div className="guide-card" key={guide.id}>
          <Link to={`/blog-guides/${guide.id}`}>
            <div
              className="guide-image"
              style={{ backgroundImage: `url(${guide.image})` }}
            />
            <div className="guide-title">
              {typeof guide.title === "object"
                ? guide.title[language] || guide.title.en
                : guide.title}
            </div>
          </Link>
        </div>
      ))}
    </div>

    <button className="scroll-btn right" onClick={() => scrollGuides('right')}>
      &gt;
    </button>
  </div>

  <Link to="/blog-guides">
    <button className="see-all-btn">
      {translations.seeAllGuides || "See All Guides"}
    </button>
  </Link>
</section>



      {/* Testimonials Section */}
      <section className="testimonials">
        <h2>{translations.testimonials}</h2>
        <div className="testimonial">
          <div className="testimonials-card">
            <p>{translations.testimonial1}</p>
          <span>{translations.daniMartins}</span>
          </div>
          <div className="testimonials-card">
          <p>{translations.testimonial2}</p>
          <span>{translations.lillian}</span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
